export default __webpack_public_path__ + "static/media/home-page.9086eef8.png";